import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme } from "../context/ThemeContext";
import { Mail, MessageCircle, Phone } from "lucide-react";

const LOGO_DARK = "https://customer-assets.emergentagent.com/job_delcielo-corp/artifacts/g54g7x2d_logo-web-dark.webp";
const LOGO_LIGHT = "https://customer-assets.emergentagent.com/job_delcielo-corp/artifacts/qdm4l4av_logo-web-light.webp";

export default function Footer() {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-secondary/30 relative overflow-hidden">
      {/* Orange accent stripe */}
      <div className="absolute top-0 left-0 h-[3px] w-24 bg-dc-amber dark:bg-dc-amber" />

      <div className="container-page py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img
            src={theme === "dark" ? LOGO_DARK : LOGO_LIGHT}
            alt="dc.TECH"
            className="h-9 w-auto mb-5"
          />
          <p className="text-muted-foreground max-w-md leading-relaxed">
            {t("footer.tagline")}
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-[0.15em] mb-4 flex items-center gap-2">
            <span className="inline-block w-6 h-[3px] bg-dc-amber rounded-full" />
            {t("footer.services")}
          </h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/capacitaciones" className="hover:text-dc-amber transition-colors">{t("nav.capacitaciones")}</Link></li>
            <li><Link to="/conferencias" className="hover:text-dc-amber transition-colors">{t("nav.conferencias")}</Link></li>
            <li><Link to="/consultorias" className="hover:text-dc-amber transition-colors">{t("nav.consultorias")}</Link></li>
            <li><Link to="/desarrollo" className="hover:text-dc-amber transition-colors">{t("nav.desarrollo")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold uppercase tracking-[0.15em] mb-4 flex items-center gap-2">
            <span className="inline-block w-6 h-[3px] bg-dc-amber rounded-full" />
            {t("footer.contact")}
          </h4>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-dc-amber" />
              <a href="mailto:Info@delcielo.tech" className="hover:text-dc-amber transition-colors">
                Info@delcielo.tech
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-dc-amber" />
              <a href="tel:+584121496804" className="hover:text-dc-amber transition-colors">
                +58 412 149 6804
              </a>
            </li>
            <li className="flex items-center gap-2">
              <MessageCircle className="w-4 h-4 text-dc-amber" />
              <a href="https://wa.me/584121496804" target="_blank" rel="noreferrer" className="hover:text-dc-amber transition-colors">
                WhatsApp
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="container-page py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <span>© {year} Delcielo Tech. {t("footer.rights")}</span>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-dc-amber">{t("footer.privacy")}</Link>
            <Link to="#" className="hover:text-dc-amber">{t("footer.terms")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
